/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SemcoArticleKinds {
    Materials = '0',
    Services = 1,
}
